import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props, d as defaults } from './componentEl-33ff2aeb.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';

/*
Generic component for a single toggle item, to be used in the context of Tab
*/

function StepItem(_ref) {
  let {
    componentEl: Component,
    className,
    children,
    complete,
    number,
    active
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children", "complete", "number", "active"]);

  const conditionalProps = {};
  const cssClasses = ['st_step'];
  if (complete) cssClasses.push('st_step--complete');

  if (active) {
    conditionalProps['aria-current'] = 'step';
    cssClasses.push('st_step--active');
  }

  if (className) cssClasses.push(className);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, conditionalProps, otherProps), /*#__PURE__*/React.createElement("span", {
    className: "st_step__number"
  }, complete ? '✓' : number), children);
}

StepItem.propTypes = {
  /** additional CSS classes for outermost element, if any */
  className: PropTypes.string,

  /** component or DOM element to use for rendering outermost tag */
  componentEl: props,

  /** whether step is completed */
  complete: PropTypes.bool,

  /** whether step is active */
  active: PropTypes.bool,

  /** number in step */
  number: PropTypes.number
}; // default props

StepItem.defaultProps = {
  className: null,
  componentEl: defaults,
  complete: false,
  active: false,
  number: null
};

/*
Generic component for Steps
Accepts one or more Steps.Item component inside
*/

function Steps(_ref) {
  let {
    componentEl: Component,
    className,
    children,
    active,
    complete,
    margin
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children", "active", "complete", "margin"]);

  let cssClasses = ['st_steps'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  let childIndex = 1;
  const childrenWithProps = React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return null;
    }

    const childNumber = child.props.number === null ? childIndex : child.props.number;
    const childActive = childNumber === active;
    const childComplete = childNumber <= complete;
    childIndex += 1;
    return React.cloneElement(child, {
      number: childNumber,
      active: childActive,
      complete: childComplete
    });
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    "aria-label": "progress",
    className: cssClasses.join(' ')
  }, otherProps), childrenWithProps);
} // proptypes definitions


Steps.propTypes = {
  /** extra CSS classes, if any */
  className: classNameProps,

  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** margin for component, if any */
  margin: marginProps,

  /** current step number */
  active: PropTypes.number,

  /** completed steps */
  complete: PropTypes.number
}; // default props

Steps.defaultProps = {
  className: null,
  margin: null,
  componentEl: defaults,
  active: 1,
  complete: 0
};
Steps.Item = StepItem;
Steps.Item.displayName = 'Steps.Item';

export default Steps;
